var heading_default = {
  "fontElementMap": "ZHbk3",
  "elementSpacing": "nOous",
  "headerOne": "NJqo5 nOous",
  "headerTwo": "CsTF7 nOous",
  "headerThree": "rxZTz nOous",
  "headerFour": "A1J0q nOous",
  "headerFive": "pd-UD nOous",
  "headerSix": "sQyNr nOous",
  "child": "GL2zY"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
